import { t } from 'i18next';

export const FILE_TYPES = {
  XLSX: 'xlsx',
  CSV: 'csv',
  PDF: 'pdf',
  XLSX_LOGISTICS: 'logistic-xlsx',
};

export const ENVIRONMENTS = {
  dev: 'develop',
  stage: 'stage',
  prod: 'production',
};

export const TABLE_DEFAULTS = {
  CURRENT_PAGE: 0,
  ROWS_PER_PAGE: 10,
  TOTAL_PAGES: 1,
  TOTAL_ROWS: 0,
};

export const FILE_UPLOAD_PATHS = {
  products: 'products',
  producer: 'producer',
  wineType: 'wineType',
  grapeType: 'grapeType',
  territory: 'territory',
  selection: 'selection',
};

export const MIME_TYPES = {
  jpg: 'image/jpg',
};

export const CLONE_QUERY = {
  clone_order_code: 'clone_order_code',
  clone_product_sku: 'clone_product_sku',
  clone_producer_slug: 'clone_producer_slug',
  clone_client: 'clone_client',
  clone_user: 'clone_user',
  clone_wine_type: 'clone_wine_type',
  clone_grape_type: 'clone_grape_type',
  clone_tasting: 'clone_tasting',
  clone_overlay_id: 'clone_overlay_id',
};

export const STAT_ROWS_PER_PAGE_OPTIONS = [25, 50, 75, 100];
export const DEFAULT_STAT_ROWS_PER_PAGE = 25;

export const INVOICE_BTN_COLOR = '#00A76F';
export const INVOICE_BTN_HOVER_COLOR = '#15bc84';

export const darkGreen = '#388E3C';
export const darkRed = '#D32F2F';
export const PAY_BTN_HOVER_COLOR = '#D3522F';
export const generateYears = (
  currentYear: number,
  add12MonthsFilter = false,
): { value: number | string; label: string }[] => {
  const yearsArray: { value: number | string; label: string }[] = Array(currentYear - 2017 + 1)
    .fill(null)
    .map((_, index) => ({
      value: 2017 + index,
      label: `${2017 + index}`,
    }));

  if (add12MonthsFilter) {
    yearsArray.push(
      { value: 'last_12_months', label: t('last_12_months') },
      { value: 'previous_12_months', label: t('previous_12_months') },
    );
  }

  return yearsArray;
};

export const months = [
  { label: 'jan', value: 1 },
  { label: 'feb', value: 2 },
  { label: 'mar', value: 3 },
  { label: 'apr', value: 4 },
  { label: 'may', value: 5 },
  { label: 'jun', value: 6 },
  { label: 'jul', value: 7 },
  { label: 'aug', value: 8 },
  { label: 'sep', value: 9 },
  { label: 'oct', value: 10 },
  { label: 'nov', value: 11 },
  { label: 'dec', value: 12 },
];

export const DEFAULT_LEAD_TIME = 14;

export const PREVIOUS_12_MONTHS = { value: 'previous_12_months', label: t('previous_12_months') };
export const LAST_12_MONTHS = { value: 'last_12_months', label: t('last_12_months') };

export const rawPriceRanges = [
  { min: 0, max: 9.99 },
  { min: 10, max: 12.99 },
  { min: 13, max: 16.99 },
  { min: 17, max: 20.99 },
  { min: 21, max: 24.99 },
  { min: 25, max: 29.99 },
  { min: 30, max: Infinity },
];
// Single few promo will be applied when there are only 1 or 2 bottles left in inventory/stock
export const SINGLE_FEW_BOTTLES_PRMOTION_QUANTITY = 2;

export const OVERDUE_QUERY_PARAM = '?overdue=true';
export const UPCOMING_QUERY_PARAM = '?status=upcoming';
